import(/* webpackMode: "eager" */ "/home/admin/prodmob-webapp/mob-webapp/src/app/[locale]/(mobility)/(content)/faq/template.tsx");
